import { SIGNAL_NAME_MAP } from "@/config";

const handleUntranslatedSignal = (label: string) => {
  return label
    .replace("mlrisk", "ML_risk")
    .replace("p2p", "P2P")
    .split("_")
    .join(" ");
};

export function getSignalTranslation(
  label: string,
  prefix: string = "signal_", // `signal_`, `src_`
) {
  return (
    SIGNAL_NAME_MAP[`${prefix}${label}` as keyof typeof SIGNAL_NAME_MAP] ||
    handleUntranslatedSignal(label)
  );
}
